import type { SVGProps } from 'react';
import * as React from 'react';

const SvgCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 12 12"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 3 4.5 8.5 2 6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgCheck02;
